import { Divider } from '@mui/material';
import { ReactComponent as NoItem } from 'assets/svg/no-my-reuqest.svg';
import BuyerPoolLoader from 'components/Loading/BuyerPoolLoader';
import ArchiveRequests from 'components/client-pool/ArchiveRequests';
import Dropdown from 'components/client-pool/DropDown';
import OpenRequestCard from 'components/client-pool/OpenRequestCard';
import { useGetPropertyRequests } from 'hooks/usePropertyRequests';
import { useState } from 'react';
import { PropertyLead } from 'types/PropertyLead';
import NoItems from './NoItems';

const sortMappings: Record<string, { sortBy: string; sortOrder: 'ASC' | 'DESC' }> = {
    'Most Saved': { sortBy: 'savedCount', sortOrder: 'DESC' },
    'Least Saved': { sortBy: 'savedCount', sortOrder: 'ASC' },
    'Least Recent': { sortBy: 'createdAt', sortOrder: 'ASC' },
};

export default function MyRequests() {
    const [selected, setSelected] = useState<'Open' | 'Archive'>('Open');

    const [selectedSortOption, setSelectedSortOption] = useState<string>('Recently Posted');

    const filters = {
        ...(selected === 'Open' && {
            ...(selectedSortOption !== 'Recently Posted' && {
                sortBy: sortMappings[selectedSortOption as string]?.sortBy,
                sortOrder: sortMappings[selectedSortOption as string]?.sortOrder,
            }),
        }),
        isArchived: selected === 'Archive' ? true : false,
    };

    const { data, isFetching } = useGetPropertyRequests(filters, false);

    const handleChange = (selectedOption: string | number) => {
        setSelectedSortOption(selectedOption as string);
        if (selectedOption === 'Recently Posted') return;
    };

    if (isFetching) return <BuyerPoolLoader />;

    return (
        <div className="pb-10 pt-6">
            <div className="flex flex-col gap-6 w-full font-poppins pt-4 bg-white min-h-screen border border-my-gray/70 rounded-lg px-6">
                <div className="flex gap-2">
                    <h6 className="font-semibold text-my-black/80 text-base ">My Requests</h6>
                    <span className="h-fit rounded-lg text-white px-2 py-0.5   bg-my-green">{data?.data?.data?.total}</span>
                </div>
                <Divider className="default-sm:block hidden" />
                <div className="flex default-sm:justify-between default-sm:items-center w-full  default-sm:flex-row flex-col gap-4">
                    <div className="inline-flex rounded-lg bg-gray-100 p-1  w-1/2 default-sm:w-auto">
                        {['Open', 'Archive'].map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setSelected(tab as 'Open' | 'Archive')}
                                className={`px-6 py-3 text-sm font-medium rounded-md transition-colors ${
                                    selected === tab ? 'bg-white shadow-sm text-my-black/80' : 'text-gray-500 hover:text-gray-900'
                                }`}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    {selected === 'Open' && (
                        <Dropdown
                            options={['Recently Posted', 'Most Saved', 'Least Saved', 'Least Recent']}
                            heightClass="h-10"
                            isShown={false}
                            widthClass=" default-sm:w-52 w-full"
                            value={selectedSortOption}
                            onChange={handleChange}
                            showClearButton={false}
                        />
                    )}
                </div>
                {data?.data?.data?.leads.length === 0 ? (
                    <NoItems
                        title="No Requests Created Yet"
                        description="Start by creating a request, and it’ll appear here for you to track and manage effortlessly!"
                        Icon={NoItem}
                    />
                ) : selected === 'Open' ? (
                    data?.data?.data?.leads.map((lead: PropertyLead) => <OpenRequestCard key={lead.id} lead={lead} />)
                ) : (
                    data?.data?.data?.leads.map((lead: PropertyLead) => <ArchiveRequests key={lead.id} lead={lead} />)
                )}
            </div>
        </div>
    );
}
